import { render, staticRenderFns } from "./ConcernAdminOverview.vue?vue&type=template&id=079fe631"
import script from "./ConcernAdminOverview.vue?vue&type=script&lang=js"
export * from "./ConcernAdminOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports